import { IWorkflow } from '@interfaces/interfaces';

export interface WfsColumn {
	id: string;
	header: string;
}

export function createColumns(workflow: IWorkflow): WfsColumn[] {
	return workflow.items.map(item => ({ id: item.id, header: item.shortName ?? item.name }));
}